import React from "react";



const Loader = () => {
  return (
    <div className="text-center my-5">
      <img className="spinner" src="https://raw.githubusercontent.com/UtkarshChaurasia/khabari/main/src/components/loading.gif" alt="loading"></img>
    </div>
  );
};

export default Loader;